import React from 'react';
import Header from '../Header';
import ProfileSidebar from '../ProfileSidebar';
import './ProfileLayout.css';

const ProfileLayout = ({ children, activeItem = null }) => {
  return (
    <div className="profile-layout">
      <Header activeNav="profile" />
      
      <main className="profile-layout__main">
        <div className="profile-layout__container">
          <div className="profile-layout__panel">
            <div className="profile-layout__content">
              {/* Боковая панель - всегда слева */}
              <ProfileSidebar activeItem={activeItem} />
              
              {/* Основной контент - справа, передается через children */}
              <div className="profile-layout__main-content">
                {children}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProfileLayout;
